var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMdkdLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 205.3 69.5",
    style: {
      enableBackground: "new 0 0 205.3 69.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E22C2C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#1A1B1D;}\n\t.st3{enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdkd_logofooter",
    transform: "translate(-378.873 -78.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4",
    transform: "translate(378.873 78.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_435",
    transform: "translate(2.744 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_6"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 23.1,
    cy: 46.4,
    r: 23.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_116"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,46.4h46.2c0,0,0.7-23.8-23.1-46.4C-0.7,22.6,0,46.4,0,46.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_117"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.3,56.7l-0.9-0.5c-1.8-1.1-3.5-2.3-5.1-3.6c-4.1-3.8-7.3-8.5-9.4-13.7l-0.1-0.2c-0.2-1.1-0.5-2.1-0.9-3.1 L37.4,34l-1.6,0.4c-2,0.5-4.1,0.8-6.1,1c-0.1-2.8-1.2-5.6-3.1-7.7c-4.2-4.6-8.8-8.8-13.8-12.5c-4.3-3.3-7.7-5.5-7.8-5.6L3.3,8.5 L1.1,7.1L0.5,9.8l-0.4,2C-0.1,13,0,14.2,0.2,15.4c0.1,0.9,0.3,1.7,0.6,2.6c-0.1,0.4-0.2,0.8-0.2,1.2c-0.2,1.4,0,2.9,0.6,4.2 c0,0.1,0,0.1,0,0.2C0.9,25.2,1,27,1.4,28.7c0.3,1.8,1.1,3.4,2.3,4.7c0.1,1.2,0.3,2.4,0.6,3.5c0.8,2.6,2.5,4.7,4.8,6.2 c0.8,1.3,1.9,2.4,3.1,3.3c1.5,1.2,3.3,2,5.1,2.6c0.5,0.2,1,0.3,1.5,0.4c-0.2,0.5-0.2,1.1-0.2,1.6l0,0.9l0.7,0.5 c2.6,1.8,5.4,3.5,8.3,4.9c3.1,1.6,6.3,3.1,9.7,4.5c4.3,1.7,8.6,3.2,13,4.4l0.8,0.2l0.8-0.6c0.8-0.7,1.4-1.6,1.6-2.7l0.1-0.4 c0.2-0.2,0.4-0.4,0.5-0.6c0.6-0.8,0.9-1.8,1-2.7l0,0c0.1-0.7,0.1-1.4,0.1-2.1v-0.2L54.3,56.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_449",
    transform: "translate(1.873 10.089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_439",
    transform: "translate(18.459 26.131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trazado_122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.9,3l12.6-1.2c2.8,8.7,8.7,16,16.6,20.7c0,0,0.8,5.5-8.8,1.9S4.5,16.1,2.4,13.9S3.1,9.7,2.9,3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_438",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trazado_123"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3.1,4.5c0,0,5.8,2.7,6.6,6.7c0.4,2.3,0.4,4.7-0.2,7c0,0-6.9-2.3-7.1-5.3C2.3,10,2.6,7.2,3.1,4.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_124"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.3,14.6C2.2,14.3,2.1,14,2,13.7c-0.1-1.1,0.1-2.1,0.4-3.2c0.5-2,0.7-4.2,0.6-6.3 c0.4,0.2,0.8,0.4,1.3,0.7C4.4,5,4.6,5.1,4.7,5.1c0,1.7-0.1,3.3-0.5,4.9c-0.6,2.6-0.9,3.9-0.4,5.6C3.3,15.3,2.8,14.9,2.3,14.6z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_125"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.9,11.4c-0.4,1.6,0.6,3.9,2.6,5.3l-3.9-2l1.1-4.1L3.9,11.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_126"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.5,10.8c0,0-4.1-0.1-6.2,2c-1.5,1.6-2.6,3.5-3.5,5.5l9.1,4.1c0.7-2.6,2.4-4.8,4.7-6.1L19.5,10.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_127"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.2,12c-4.4,0.1-8.3,3.1-9.4,7.4l-1.8-1c1.8-4.2,5.7-7.2,10.3-7.6L20.2,12z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_128"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.6,21.4c-3.1-1.3-6.2-2.8-9.1-4.5l-0.9,2.5l8.3,4.3L19.6,21.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_129"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3.7,4.9c1.9,0.2,3.9,0.2,5.8,0c2-0.2,3.9-0.5,5.8-1c2.2,5.7,5.8,10.9,10.3,15c1.8,1.5,3.6,2.8,5.6,4 c-0.1,1.2-0.8,1.8-2.2,1.9c-1.9,0-3.7-0.3-5.5-1c-5-1.6-11.1-4.9-14.6-6.5s-6.2-2.8-6.2-5c0-1,0.5-2.7,0.6-3.8 C3.6,7.3,3.7,6.1,3.7,4.9 M2,3.1l0,1.8c0,1.1-0.1,2.3-0.3,3.4c0,0.4-0.2,0.9-0.3,1.4c-0.2,0.9-0.3,1.8-0.4,2.6 c0.1,1.7,1,3.2,2.5,4.1c1.5,0.9,3,1.8,4.7,2.4c1,0.4,2.2,1,3.5,1.7c3.7,1.9,7.4,3.5,11.3,4.9c2,0.7,4,1.1,6.1,1.1 c1.9,0,3.5-1.5,3.7-3.4l0.1-1l-0.9-0.5c-1.9-1.1-3.7-2.4-5.3-3.8c-4.3-4-7.7-8.9-9.9-14.4l-0.6-1.4l-1.5,0.4 C13,2.8,11.2,3.1,9.3,3.2c-1.8,0.2-3.7,0.2-5.5,0L2,3.1L2,3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_436",
    transform: "translate(3.159 3.933)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trazado_130"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M6.9,14.3l-0.8-0.2c0,0,0-0.2,0.1-0.5C6.9,11,6.6,8.3,5.5,5.9c-1.2-2.3-3.1-4-5.5-5L0.3,0 C2.8,1.1,5,3,6.2,5.5c0.9,1.7,1.3,3.7,1.2,5.6c0.1-0.2,0.3-0.4,0.5-0.7c2.1-2.5,5.2-4.1,8.5-4.2l0.1,0.9 c-3,0.1-5.9,1.5-7.8,3.9c-0.7,0.9-1.2,1.8-1.6,2.8C7,14.1,6.9,14.3,6.9,14.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_437",
    transform: "translate(18.553 16.075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trazado_131"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0.9,7L0,6.9c0.6-3,2.6-5.6,5.4-6.9l0.3,0.8C3.2,2,1.4,4.3,0.9,7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_132"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1.9,12.9c-0.5,0-1,0.1-1.4,0.3c-0.4,0.4-0.5,1-0.5,1.6c0,0,11.3,8.3,30.4,13.5c0.5-0.4,0.8-0.9,0.9-1.5 c-0.4-0.5-0.9-1-1.4-1.5c0,0-6.7,0.3-16.9-4.8S1.9,12.9,1.9,12.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_133"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2,23.3c-0.5-0.2-0.9-0.5-1.3-0.8c-0.3-0.2-0.5-0.6-0.5-1c-0.3,0.4-0.3,0.9,0.1,1.2C29,23.1,29.6,23.3,30.2,23.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_134"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2.1,4.6C2,3.5,2,2.4,2.1,1.3C6.7,1.5,11.4,1,15.9,0c0.4,1.1,0.7,2.3,0.9,3.4L8.9,3.9L2.1,4.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_135"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.4,37.8L24,38.1c-0.6,0.5-1.4,0.8-2.1,1l0-1.3L24.4,37.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_447"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_440"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trazado_136"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.6,37.8c-0.5,0-1-0.1-1.5-0.3c-0.4,0-0.7,0-1.1,0c-5.8,0-9.3-1.8-11.3-3.2c-1.1-0.8-2.1-1.9-2.8-3.1 c-2-1.1-3.5-2.9-4.2-5.1c-0.4-1.2-0.6-2.6-0.5-3.9C3.1,21.1,2.2,19.7,2,18c-0.3-1.5-0.3-3-0.2-4.5c0-0.3,0-0.6,0.1-0.9 c-0.8-1.5-0.9-3.4-0.3-5C1.2,6.8,1,5.9,0.8,4.9C0.7,4,0.6,3.1,0.7,2.1l0.2-1l0.9,0.6c0.1,0.1,13.5,8.8,21,17.6 c1.6,1.9,2.5,4.3,2.5,6.8c0,0.1,0,0.1,0,0.2v0c0,0.3,0,0.6,0,0.9c-0.1,1.3,0.1,2.6,0.7,3.7l0,0c0.9,1.9,1.4,4,1.3,6l0,0.4 l-0.4,0.2C26.5,37.7,26.1,37.8,25.6,37.8L25.6,37.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trazado_137"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1.4,2.3c0,0,13.3,8.7,20.9,17.5c1.5,1.7,2.3,4,2.3,6.3c0,0.1,0,0.1,0,0.2l0,0c0,0.3,0,0.6,0,0.9 c-0.1,1.4,0.1,2.8,0.8,4c0.9,1.8,1.3,3.7,1.3,5.7c-0.3,0.1-0.6,0.2-1,0.2c-0.5,0-0.9-0.1-1.4-0.3c-0.4,0-0.8,0-1.2,0 c-10.9,0-13.5-6.2-13.5-6.2C4.9,28.3,4.9,23,5,22c0-0.1,0-0.2,0-0.2c-2.7-1.7-2.8-6.1-2.6-8.2c0-0.4,0-0.7,0.1-1.1 c-1.5-2-0.3-4.8-0.3-4.8c-0.4-0.9-0.7-1.9-0.8-3C1.3,3.9,1.3,3.1,1.4,2.3 M0.4,0L0.1,2C-0.1,3,0,4,0.1,5 c0.1,1,0.4,1.9,0.7,2.8c-0.2,0.5-0.3,1-0.3,1.5c-0.2,1.2,0,2.5,0.6,3.6c0,0.2,0,0.5-0.1,0.7C1,15.1,1,16.7,1.3,18.2 c0.3,1.7,1.1,3.2,2.3,4.3c0,1.3,0.2,2.5,0.6,3.8c0.7,2.3,2.3,4.2,4.3,5.4c0.7,1.2,1.7,2.3,2.8,3.2c1.4,1,2.9,1.8,4.5,2.3 c2.3,0.7,4.7,1.1,7.1,1c0.3,0,0.6,0,1,0c0.5,0.2,1.1,0.3,1.6,0.3c0.5,0,1.1-0.1,1.6-0.4l0.7-0.4l0-0.8 c0-2.2-0.5-4.4-1.4-6.4l0,0l0,0c-0.5-1-0.7-2.2-0.6-3.4c0-0.3,0-0.6,0-0.9v0v0c0,0,0-0.1,0-0.2c0.1-2.7-0.9-5.2-2.6-7.2 c-4.1-4.5-8.6-8.6-13.5-12.2C5.6,3.4,2.3,1.2,2.2,1.1L0.4,0L0.4,0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_445",
    transform: "translate(1.154 9.497)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_441",
    transform: "translate(4.283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trazado_138"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M18.4,22.5c-0.4-0.2-0.8-0.5-1.1-0.9c-0.8-1.2-1.3-2.5-1.3-4v-0.1c-0.2-2.2-0.3-3.6-1.2-5.2 c-0.9-1.5-2.5-3.2-5.8-5.8c-1.6-1.3-3-2.4-4.2-3.3C3.3,2.1,1.7,1,0,0c1.1,1.2,2.3,2.3,3.5,3.2l0,0c1.4,1.1,3,2.4,5,4 c6.2,5.1,6.3,6.2,6.6,10.5v0.1c0,0.5,0.1,1.1,0.2,1.6C16.3,22.5,18.4,22.5,18.4,22.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_442",
    transform: "translate(0 1.591)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trazado_139"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0.7,0L0,0.2c0.5,1.4,1.4,2.6,2.5,3.6c1.4,1.3,3,2.3,4.8,2.9C3.5,4.1,1.1,1.6,0.7,0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_443",
    transform: "translate(0.557 9.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trazado_140"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0.7,0L0,0.3c0.7,1.3,1.7,2.4,3,3.2c1.6,1.1,3.3,1.8,5.2,2.2C4.1,3.6,1.3,1.6,0.7,0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_444",
    transform: "translate(6.051 19.919)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trazado_141"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0.3,0C0.2,0.2,0.1,0.5,0,0.7C0.4,1,0.9,1.3,1.4,1.5C3,2.4,4.9,2.9,6.8,2.9C4.5,2.3,2.3,1.3,0.3,0z"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M464.3,118.1h-3.2v-8.6l-5.2,8.6h-2.3l-5.2-8.6v8.6H445v-12.6h4.4l5.3,8.9l5.3-8.9h4.4V118.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M469.7,108v2.6h10.1v2.3h-10.1v2.6h10.1v2.6h-13.3v-12.6h13.3v2.6H469.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M496.9,111.7c0,4.3-2.9,6.3-6.1,6.3h-9.1v-12.6h9.1C494.1,105.4,496.9,107.5,496.9,111.7z M493.7,111.7 c0-3.1-1.7-3.6-4.1-3.6h-4.7v7.2h4.7C492,115.3,493.7,114.8,493.7,111.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M502,118.1h-3.2v-12.6h3.2V118.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M513.7,111l7.6,7h-4.5l-5.5-5.2l-3.9,2.8v2.4h-3.2v-12.6h3.2v6.5l9-6.5h4.9L513.7,111z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M525.6,110.8h-2.6l0.7-5.8h3.1L525.6,110.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M544.4,111.7c0,4.3-2.9,6.3-6.1,6.3h-9.1v-12.6h9.1C541.5,105.4,544.4,107.5,544.4,111.7z M541.2,111.7 c0-3.1-1.7-3.6-4.1-3.6h-4.7v7.2h4.7C539.5,115.3,541.2,114.8,541.2,111.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M546.1,111.7c0-4.2,2.4-6.5,7.9-6.5c5.5,0,7.9,2.3,7.9,6.5c0,4.2-2.4,6.5-7.9,6.5 C548.5,118.2,546.1,115.9,546.1,111.7z M558.7,111.7c0-2.6-1.3-3.7-4.7-3.7s-4.7,1.2-4.7,3.7c0,2.6,1.3,3.8,4.7,3.8 S558.7,114.3,558.7,111.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M583.1,118.1h-3.2v-8.6l-5.2,8.6h-2.3l-5.2-8.6v8.6h-3.2v-12.6h4.4l5.3,8.9l5.3-8.9h4.4V118.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdkdLogo);
export default __webpack_public_path__ + "static/media/mdkd_logo.e378e9fd05a842ac598335fab129ac8a.svg";
export { ForwardRef as ReactComponent };